// MonthlyPieChart.js
import React from 'react';
import { Pie } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend
} from 'chart.js';
import { getColorsForLabels } from '../utils/colorMap';

ChartJS.register(ArcElement, Tooltip, Legend);

const ProductChart = ({ productCountByCategory }) => {
    const labels = productCountByCategory.map(item => item.category);
    const totals = productCountByCategory.map(item => item.count);
    const colors = getColorsForLabels(labels);
    const data = {
        labels,
        datasets: [
            {
                data: totals,
                backgroundColor: colors,
                borderWidth: 0
            }
        ]
    };

    const options = {
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context) {
                        return `${context.parsed}`;
                    }
                }
            },
            legend: {
                display: false,
                // labels: {
                //     usePointStyle: true,
                //     pointStyle: 'circle' 
                // }
            }
        },
        responsive: true,
        maintainAspectRatio: false
    };

    return (
        <div className="reportmap_1s">
            <div className="reportmap_1stext">
                <div className="thismonth">Products Purchased <br />by Category</div>
            </div>
            <div style={{ width: '274px', height: 'auto' }}>
                <Pie data={data} options={options}/>
            </div>
        </div>

    );
};

export default ProductChart;
